import { ReactNode } from "react";
import { LandingNav } from "./LandingNav";
import { Footer } from "./Footer";
import { AuroraBackground } from "@/components/ui/aurora-background";

interface PublicPageLayoutProps {
  children: ReactNode;
}

export function PublicPageLayout({ children }: PublicPageLayoutProps) {
  return (
    <div className="min-h-screen bg-background overflow-x-hidden landing-page relative">
      <AuroraBackground />
      <div className="relative z-10">
        <LandingNav />
        <main className="pt-24">
          {children}
        </main>
        <Footer />
      </div>
    </div>
  );
}

